var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurveTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21v.441h375V21s-84.258.402-99.973-3.059C232.753 10.74 227 0 187.5 0s-40.1 9.312-90.758 17.941C81.656 21.984 0 21 0 21z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
export default SvgCurveTop;